import { Box, ButtonBase, Slide, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";
import { useTranslation } from "react-i18next";
import Subheading from "../../../../../components/theme/text/Subheading";
import EcheckCarrier from "../../components/EcheckCarrier";
import { DropdownBase, ShDropdownQuery } from "../../../../../components/theme/dropdowns/Dropdown";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import { getShipperColorSettingsByType } from "../../../../../components/Streams/StreamShipperSettings";
import Text from "../../../../../components/theme/text/Text";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ShSwitch from "../../../../../components/theme/inputs/ShSwitch";
import Truck from "../../components/truck/Truck";
import { ReactComponent as BolLogo } from '../../../../../styles/svg/bol.svg';
import { ReactComponent as DhlLogo } from '../../../../../styles/svg/dhl.svg';
import { ReactComponent as DhlGermanyLogo } from '../../../../../styles/svg/dhlgermany.svg';
import { ReactComponent as DpdLogo } from '../../../../../styles/svg/dpd.svg';
import { ReactComponent as PostNLLogo } from '../../../../../styles/svg/postnl.svg';
import Heading from "../../../../../components/theme/text/Heading";
import { useEffect, useMemo, useState } from "react";
import SpOrderDetails from "../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails";
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { hexToRgb } from "../../../../../utils/colorConverters";
import EcheckInvoiceCosts from "../../components/InvoiceCosts";
import CarrierView from "../../components/views/CarrierView";
import { bundleCarriers, filterShipperProfilesByDeliveryCountry, getOrderDeliveryCountry } from "../../helper";
import { useSelector } from "react-redux";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { useEditOrderCarrierMutation } from "../../../../../newapi/order/ordersSlice";
import { UserPrivileges } from "../../../../../utils/permissions";
import EditCarrierPreviousOrderDropdownItem from "../../components/EditCarrierPreviousOrderDropdownItem";
import { useGetCarriersSelectQuery } from "../../../../../newapi/carrier/carrierSlice";
import { showToastMessage, showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../../utils/toasts";

const EcheckView = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const [spLoading, setSpLoading] = useState(false);
    const [orderOpen, setOrderOpen] = useState(false);
    const [orderId, setOrderId] = useState(null);
    
    const [editCarrierResponse,{isLoading:carrierEditLoading}] = useEditOrderCarrierMutation();

    const openOrder = () => {
        // Only update state if the orderId has actually changed
        //if(!spLoading) {
            setOrderId(props.currentOrder?.id);
            setSpLoading(true);
            setOrderOpen(true);
        //}
    }

    const ShipperLogoMap = {
        postnl: PostNLLogo,
        dhl: DhlLogo,
        dhlgermany: DhlGermanyLogo,
        dpd: DpdLogo,
        bol: BolLogo,
      };

    const renderShipperLogo = (shipperType) => {
        // Get the logo component based on shipper type
        const LogoComponent = ShipperLogoMap[shipperType];

        // Render the logo component if it exists, or null otherwise
        return LogoComponent ? <LogoComponent className={shipperType} /> : null;

    };
    const [toScan, setToScan] = useState(null);
    useEffect(() => {
        // Total of the whole order: auto-processed add-ons are already placed in the first
        // carrier, so they are not part of toScanRows and must still be counted here.
        setToScan(props.maxCarrierAmount ?? props.toScanRows.reduce((total, row) => total + row.amount, 0))
    },[])
    
    const [textKey, setTextKey] = useState('echeck_processing_order');
    useEffect(() => {
        let timer;
        if (props.finalizeLoading) {
            timer = setTimeout(() => {
                setTextKey('e_check_you_have_5_seconds_secondary');
            }, 3000);
        } else {
            setTextKey('echeck_processing_order'); // reset if not loading
        }

        return () => clearTimeout(timer);
    }, [props.finalizeLoading]);

    const hasOutboundInstructions = useMemo(
        () =>
            props.toScanRows?.some(
                (row) => row.product.outboundInstruction?.trim()
            ),
        [props.toScanRows]
    );


    const [carrier,setCarrier] = useState({
        id: -1,
        title: t("no_carrier_advice")
    });

    useEffect(() => {
        if(props.currentOrder.suggestedCarrier) {
            setCarrier(props.currentOrder.suggestedCarrier)
        }

    },[props.currentOrder])

    
    const [editCarrierModalOpen, setEditCarrierModalOpen] = useState(false);
    const editCarrier = async () => {
        if(carrierEditLoading) return;
        try{
            const resp = await editCarrierResponse({
                orderId: props.currentOrder.id,
                suggestedCarrierId:carrier.id
            }).unwrap();

            showToastMessageUpdateRequest(t,resp);
        }
        catch (error) {
            showToastMessageRequestError(t("edit_failed"), t, error);
        }
    }

    const canEditCarrier = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.PRODUCT_MANAGE])
    ) && !(props.currentOrder?.amountOfProducts === 1 && props.currentOrder?.orderlines[0]?.product?.carrierId > 0 );
    
    const confirmEditCarrier = {
        open: editCarrierModalOpen,
        setOpen: setEditCarrierModalOpen,
        confirm: editCarrier
    }
    
    const carrierIsSet = props.carriers?.[0]?.carrierId === carrier?.id || (props.carriers?.length === 1 && carrier?.type === "own");

    return (
        <>
            <Box
                sx={{
                    flex:1,
                    flexDirection: "column",
                    display:"flex",
                    p:2,
                    borderRadius:4,
                    position:'relative',
                    // borderTopLeftRadius:16,
                    // borderTopRightRadius:16,
                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                    overflow:'auto',
                }}
            >

                <Box
                    sx={{
                        display:"flex",
                        alignItems:'center',
                        gap:6,
                    }}
                >

                    <Box
                        sx={{
                            display:"flex",
                            alignItems:'center',
                            flex:1,
                        }}
                    >
                        {!props.isBundling ?
                        <>
                            <Box
                                sx={{
                                    display:"flex",
                                    alignItems:'center',
                                    mr:2,
                                    px:1.5,
                                    height:32,
                                    background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                    borderRadius:4,
                                }}
                            >
                                <Heading sx={{fontWeight:"1000"}}>{props.totalAmount} / </Heading>&nbsp;
                                <Heading sx={{fontWeight:"1000",color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}}>
                                    {toScan}
                                </Heading>
                            </Box>
                            <Subheading light>{t("products")}</Subheading>&nbsp;
                            <Subheading light>{t("processed")}</Subheading>&nbsp;
                            <Subheading light>in</Subheading>&nbsp;
                            <Subheading>{props.carriers?.length}</Subheading>&nbsp;
                            <Subheading light>{t("carriers")}</Subheading>

                            {props.carriers?.filter(c => !c.bundle).length > 1 && (
                                <Shbutton  
                                    onClick={() => props.setIsBundling(true)}
                                    variant={'contained'}
                                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                                    size="32"
                                    sx={{
                                        ml: "auto",
                                    }}
                                >
                                    {t("bundle")}
                                </Shbutton>
                            )}
                        </>
                        : 
                        <Box
                            sx={{
                                flex:1,
                                display:'flex',
                            }}
                        >

                            <Shbutton  
                                onClick={() => props.setIsBundling(false)}
                                variant={'contained'}
                                color={"primaryGrey"} 
                                size="32"
                                sx={{
                                    mr:2,
                                }}
                            >
                                {t("stop_bundle")}
                            </Shbutton>

                            <DropdownBase
                                key={props.newBundleName}
                                transformOrigin={{
                                    vertical: "bottom"
                                }}
                                anchorOrigin={{
                                    vertical:"top"
                                }}
                                displayName={"name"} 
                                onChange={(selected) => {
                                    var carrier = props.carriersSelect[selected];
                                    if(carrier){
                                        props.setNewBundleName(carrier);
                                    }
                                }}
                                noSelection={t("choose_carrier")} //Custom text when nothing is selected
                                options={props.carriersSelect}
                                selected={props.carriersSelect.findIndex((carrier) => carrier.id === props.newBundleName?.id) ?? -1}
                                closeOnSelection
                            >
                                <Shbutton 
                                size="32"
                                    className={"group-btn"}  
                                    sx={{whiteSpace:"nowrap"}} 
                                    color={"primaryGrey"} 
                                    variant="contained"
                                >
                                    {props.newBundleName ? props.newBundleName.name : t("choose_carrier")}
                                </Shbutton>
                            </DropdownBase>

                            <Shbutton  
                                onClick={() => {
                                    const { carriers, newBundle, setCarriers, setIsBundling,setNewBundle,setNewBundleName,setCarrierToAddTo } = props;

                                    if(!props.newBundleName) {
                                        if(props.playError) props.playError();
                                        props.setHighlightColor("red");
                                        return;
                                    }
                                    if (newBundle.length < 2) {
                                        if(props.playError) props.playError();
                                        props.setHighlightColor("red");
                                        return;
                                    }
                                    const { carriers: updatedCarriers, strippedShipperOverride } = bundleCarriers(newBundle,props.newBundleName,carriers);

                                    setCarriers(updatedCarriers);

                                    setNewBundle([]);
                                    setNewBundleName();
                                    setIsBundling(false);
                                    setCarrierToAddTo(null);
                                    if(strippedShipperOverride) showToastMessage("warning", t("custom_shipper_override_reset_on_bundle"));
                                    if(props.playSuccess) props.playSuccess();
                                }}
                                variant={'contained'}
                                color={"green"}
                                size="32"
                                sx={{
                                    ml:1.5,
                                }}
                            >
                                {t("create_bundle")}
                            </Shbutton>
                        </Box>
                        }
                    </Box>


                    <Box
                        sx={{
                            display:"flex",
                            alignItems:'center',
                            flex:1,
                        }}
                    />
                </Box>

                
                <Box
                    sx={{
                        mt:2,
                        display:'flex',
                        alignItems:"flex-start",   
                        gap:3,
                    }}
                >
                    
                    <CarrierView
                        hasAllowedToSetCustomCarrierShipperPermission={props.hasAllowedToSetCustomCarrierShipperPermission}
                        setGoFinalize={props.setGoFinalize}
                        autoFinalize={props.autoFinalize}
                        carrierMandatory={props.carrierMandatory}
                        selectedShipper={props.selectedShipper}
                        selectedShipperProfile={props.selectedShipperProfile}
                        maxCarrierAmount={props.maxCarrierAmount}
                        carrierToAddTo={props.carrierToAddTo}
                        setCarrierToAddTo={props.setCarrierToAddTo}
                        newBundle={props.newBundle}
                        setNewBundle={props.setNewBundle}
                        setCarriers={props.setCarriers}
                        playError={props.playError}
                        playSuccess={props.playSuccess}
                        isBundling={props.isBundling}
                        toScanRows={props.toScanRows}
                        carriers={props.carriers}
                        deliveryOptions={props.deliveryOptions}
                        selectLabel={props.selectLabel}
                        selectManualCarrier={props.selectManualCarrier}
                        OwnCarrierClick={props.OwnCarrierClick}
                        carriersSelect={props.carriersSelect}

                        invoiceProducts={props.invoiceProducts}
                        setInvoiceProducts={props.setInvoiceProducts}
                        updateCostProduct={props.updateCostProduct}
                        invoiceProductsEcheck={props.invoiceProductsEcheck}
                        setToScanRows={props.setToScanRows}
                        setOriginalOrderlines={props.setOriginalOrderlines}
                        setSkuSerialMap={props.setSkuSerialMap}
                        setHighlightColor={props.setHighlightColor}
                        shippers={props.shippers}
                        currentOrder={props.currentOrder}
                        clearInstructionShown={props.clearInstructionShown}
                    />

                    <Box
                        sx={{
                            opacity:!props.isBundling ? 1 : 0.35,
                            minHeight:120,
                            // height:50,
                            position:'sticky',
                            top:0,
                            borderRadius:4,
                            p:1.5,
                            flex:1,
                            boxShadow:`0px 2px 4px ${getShipperColorSettingsByType(props.selectedShipper?.type).streamrulehover}`,
                            border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100]}`,
                            // background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                            background: getShipperColorSettingsByType(props.selectedShipper?.type).background,
                            transition: 'background-color 0.5s',
                        }}
                    >
                            {props.currentOrder.isB2B &&
                                <Box
                                    sx={{
                                        mx:1.5,
                                        mb:1,
                                        mt:1.5,
                                        fontSize:16,
                                        fontFamily:"Roboto, sans-serif",
                                        fontWeight:700,
                                        height:32,
                                        borderRadius:4,
                                        textAlign:"center",
                                        lineHeight:"32px",
                                        background:getShipperColorSettingsByType(props.selectedShipper?.type).base,
                                        color:getShipperColorSettingsByType(props.selectedShipper?.type).background,
                                    }}
                                >
                                    {t("b2b_order")}
                                </Box>
                            }

                            {props.currentOrder.remark?.trim().length > 0 && (
    
                                <Box
                                    sx={{
                                        background:getShipperColorSettingsByType(props.selectedShipper?.type).base,
                                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                        p:1.5,
                                        borderRadius:3,
                                    }}
                                >
                                    <Subheading
                                        color={getShipperColorSettingsByType(props.selectedShipper?.type).background}
                                    >
                                        {t("remark")}
                                    </Subheading>
                                    <Text
                                        color={getShipperColorSettingsByType(props.selectedShipper?.type).background}
                                    >
                                        {props.currentOrder.remark.trim()}
                                    </Text>
                                </Box>
                            )}
                            <Box
                                sx={{
                                    display:"flex",
                                    justifyContent:"space-between",
                                    alignItems:'center',
                                }}
                            >
                                
                                <Box
                                    sx={{
                                        pl:1.5,
                                        pt:1.5,
                                    }}
                                >
                                    <Subheading
                                        color={
                                            tokens("white").txt["primary"]
                                        }
                                    >
                                        <span style={{cursor: "pointer"}} onClick={() => openOrder()}>{props.currentOrder?.barcode}<Box sx={{display:"inline-block", scale: "0.7"}}><OpenInNewOutlinedIcon/></Box></span>
                                        <br/>
                                        {props.currentOrder?.deliveryName}
                                    </Subheading>
                                    
                                </Box>
                                <Box
                                    sx={{
                                        mt:1.5,
                                        mr:1.5,
                                        mb:1,
                                        height:40,
                                        display:"flex",
                                        alignItems:'center',
                                        px:2,
                                        pl:0.5,
                                        gap:1.5,
                                        borderRadius:5,
                                        background:getShipperColorSettingsByType(props.selectedShipper?.type).background,
                                        color: getShipperColorSettingsByType(props.selectedShipper?.type).base,
                                        fontWeight:"bold",
                                        border: `1px solid ${getShipperColorSettingsByType(props.selectedShipper?.type).base}`,
                                        "& .postnl" : {
                                            width:24,
                                            height:24,
                                        },
                        
                                        "& .dpd" : {
                                            width:24,
                                            height:24,
                                        },
                                        "& .dhl" : {
                                            width:24,
                                            height:24,
                                        },
                                        "& .dhlgermany" : {
                                            width:24,
                                            height:24,
                                        },
                                        "& .bol" : {
                                            width:32,
                                            // width:24,
                                            height:16,
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            height:32,
                                            width:32,
                                            borderRadius:4,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:'center',
                                            background:getShipperColorSettingsByType(props.selectedShipper?.type).streamrule,
                                            fill:"white",
                                            "& svg" : {
                                                // fill:"white",
                                            },
                                            "& svg *" : {
                                                // fill:"white",
                                            }
                                        }}

                                    >
                                        {renderShipperLogo(props.selectedShipper?.type)}
                                    </Box>
                                    {props.selectedShipper?.name}
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    p:1.5,
                                    mb:1,
                                }}
                            >

                                <Text
                                    color={
                                        tokens("white").txt["primary"]
                                    }
                                >
                                    {props.currentOrder?.shippingAddress?.addressLine1}
                                </Text>
                                <br/>

                                
                                <Text
                                    color={
                                        tokens("white").txt["primary"]
                                    }
                                >
                                    {props.currentOrder?.shippingAddress?.postalCode}, {props.currentOrder?.shippingAddress?.city}
                                </Text>
                                <br/>
                                
                                <Text
                                    color={
                                        tokens("white").txt["primary"]
                                    }
                                >
                                    {props.currentOrder?.shippingAddress?.state}, {props.currentOrder?.shippingAddress?.country}
                                </Text>
                                <br/>
                            </Box>
                            <Box
                                sx={{
                                    background:getShipperColorSettingsByType(props.selectedShipper?.type).streamrule,
                                    borderRadius:3,
                                    p:1.5,
                                }}
                            >
                                
                                {carrier && carrier.id > 0 ?
                                    (() => {
                                        const parsed = carrier.color ? JSON.parse(carrier.color) : null;
                                        let bg = getShipperColorSettingsByType(props.selectedShipper?.type).streamrulehover;
                                        if(parsed && parsed.hex) {
                                            let temp = hexToRgb(parsed.hex);
                                            bg = `rgb(${temp})`;
        
                                        } 
                                        
                                        return (
        
                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    alignItems:"center",
                                                    borderRadius:7,
                                                    height:40,
                                                    px:0.5,
                                                    // background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                                    // background:`rgb(${color?.[0]}, ${color?.[1]}, ${color?.[2]})`,
                                                    // background: `linear-gradient(rgba(${rgb?.[0] ?? '255'}, ${rgb?.[1]?? '255'}, ${rgb?.[2]?? '255'},1), rgba(${rgb?.[0]?? '255'}, ${rgb?.[1]?? '255'}, ${rgb?.[2]?? '255'},1)), ${theme.palette.mode === "dark" ? "black" : "white"}`, /* Solid white background */
                                                    background:bg,
                                                    "@media screen and (max-width: 566px)" : {
                                                        // px:3,
                                                    }
                                                }}
                                            >
                                                
                                                <Box
                                                    sx={{
                                                        height:32,
                                                        px:1.5,
                                                        // background:'orange',
                                                        lineHeight:"32px",
                                                        borderRadius:4,
                                                        background: carrierIsSet
                                                            ? colors.orange[400]
                                                            : (theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]),
                                                        color: carrierIsSet
                                                            ? (theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"])
                                                            : colors.txt["primary"],
                                                        boxShadow: theme.palette.mode === "dark" ? null : `0px 2px 4px ${colors.grey[200]}`,
                                                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                                        fontSize:14,
                                                        fontWeight: carrierIsSet ? 700 : 500,
                                                    }}
                                                >
                                                    {carrierIsSet ? t("carrier_set") : t("carrier_advice")}
                                                </Box>
                                                
                                                <Box
                                                    sx={{
                                                        ml:0.5,
                                                        lineHeight:"32px",
                                                        textAlign:"center",
                                                        // width:100,
                                                        px:2,
                                                        height:32,
                                                        borderRadius:4,
                                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                                        color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"],
                                                        fontSize:14,
                                                        fontWeight:700,
                                                        "@media screen and (max-width: 566px)" : {
                                                            flex:1,
                                                        }
                                                    }}
                                                >
                                                    {carrier.name}
                                                </Box>
        
                                                {canEditCarrier &&
                                                    <>
                                                        <ShDropdownQuery
                                                            name="name"
                                                            onChange={(selected,object) => {
                                                                setCarrier(object);
                                                            }}
                                                            valueKey={"id"}
                                                            dataKey={null}
                                                            shComponent={<EditCarrierPreviousOrderDropdownItem/>}
                                                            selected={carrier?.id ?? -1}
                                                            // selected={-1}
                                                            content={useGetCarriersSelectQuery}
                                                            closeOnSelection
                                                            displayName="name"
                                                            searchOptions={{
                                                                enabled:true,
                                                                placeholder: t("search")
                                                            }}
                                                        >
                                                            {({anchorEl,onClick}) => (
                                                                <ButtonBase
                                                                    onClick={onClick}
                                                                    sx={{
                                                                        ml:"auto",
                                                                        width:32,
                                                                        height:32,
                                                                        borderRadius:5,
                                                                        // background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[400],
                                                                        // background:getShipperColorSettingsByType(props.selectedShipper?.type).base,
                                                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                                                                        display:"flex",
                                                                        alignItems:'center',
                                                                        px:0.5,
                                                                        color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                                                    
                                                                    }}
                                                                >
                                                                    <EditOutlinedIcon fontSize="small"/>
                                                                </ButtonBase>
                                                            )}
                                                        </ShDropdownQuery>
        
                                                        <ButtonBase
                                                            onClick={() => confirmEditCarrier.setOpen(true)}
                                                            sx={{
                                                                ml:0.5,
                                                                // width:32,
                                                                px:2,
                                                                height:32,
                                                                borderRadius:5,
                                                                // background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[400],
                                                                // background:getShipperColorSettingsByType(props.selectedShipper?.type).base,
                                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                                                                display:"flex",
                                                                alignItems:'center',
                                                                color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                                                fontFamily:"Roboto, sans-serif",
                                                                fontWeight:500,
                                                            }}
                                                        >
                                                            {t("save")}
                                                        </ButtonBase>
                                                    </>
                                                }
        
                                            </Box>
                                        )
                                    })()
                                : 
                                    <Box
                                        sx={{
                                            display:"flex",
                                            alignItems:'center',
                                            height:40,
                                            background:getShipperColorSettingsByType(props.selectedShipper?.type).streamrulehover,
                                            border:`1px solid ${getShipperColorSettingsByType(props.selectedShipper?.type).base}`,
                                            boxShadow:`0px 2px 4px ${getShipperColorSettingsByType(props.selectedShipper?.type).base}`,
                                            px:0.5,
                                            borderRadius:5,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display:"flex",
                                                alignItems:'center',
                                            }}
                                        >
                                            
                                            <Box
                                                sx={{
                                                    height:32,
                                                    px:1.5,
                                                    // background:'orange',
                                                    lineHeight:"32px",
                                                    borderRadius:4,
                                                    background: carrierIsSet
                                                        ? colors.orange[400]
                                                        : (theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]),
                                                    color: carrierIsSet
                                                        ? (theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"])
                                                        : colors.txt["primary"],
                                                    boxShadow: theme.palette.mode === "dark" ? null : `0px 2px 4px ${colors.grey[200]}`,
                                                    border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                                    fontSize:14,
                                                    fontWeight: carrierIsSet ? 700 : 500,
                                                }}
                                            >
                                                {carrierIsSet ? t("carrier_set") : t("carrier_advice")}
                                            </Box>
                                            <Text color={getShipperColorSettingsByType(props.selectedShipper?.type).base} bold>
                                                {carrier && carrier.id > 0 ? 
                                                    carrier.name : 
                                                    t("no_carrier_advice")
                                                }
                                            </Text>
                                        </Box>
        
        
                                        {canEditCarrier &&
                                            <>
                                                <ShDropdownQuery
                                                    name="name"
                                                    onChange={(selected,object) => {
                                                        setCarrier(object);
                                                    }}
                                                    valueKey={"id"}
                                                    dataKey={null}
                                                    shComponent={<EditCarrierPreviousOrderDropdownItem/>}
                                                    selected={carrier?.id ?? -1}
                                                    // selected={-1}
                                                    content={useGetCarriersSelectQuery}
                                                    closeOnSelection
                                                >
                                                    {({anchorEl,onClick}) => (
                                                        <ButtonBase
                                                            onClick={onClick}
                                                            sx={{
                                                                ml:"auto",
                                                                width:32,
                                                                height:32,
                                                                borderRadius:5,
                                                                // background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[400],
                                                                // background:getShipperColorSettingsByType(props.selectedShipper?.type).base,
                                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                                                                display:"flex",
                                                                alignItems:'center',
                                                                px:0.5,
                                                                color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                                            
                                                            }}
                                                        >
                                                            <EditOutlinedIcon fontSize="small"/>
                                                        </ButtonBase>
                                                    )}
                                                </ShDropdownQuery>
        
                                                <ButtonBase
                                                    // onClick={onClick}
                                                    onClick={() => confirmEditCarrier.setOpen(true)}
                                                    sx={{
                                                        ml:0.5,
                                                        // width:32,
                                                        px:2,
                                                        height:32,
                                                        borderRadius:5,
                                                        // background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[400],
                                                        // background:getShipperColorSettingsByType(props.selectedShipper?.type).base,
                                                        
                                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                                                        display:"flex",
                                                        alignItems:'center',
                                                        color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                                        fontWeight:500,
                                                        fontFamily:"Roboto, sans-serif",
                                                    }}
                                                >
                                                    {/* <EditOutlinedIcon fontSize="small"/> */}
                                                    {t("save")}
                                                </ButtonBase>
                                            </>
                                        }
                                        
                                    </Box>
                                }

                                <Box
                                    sx={{
                                        mt:2,
                                    }}
                                >
                                    
                                    <Box
                                        sx={{
                                        }}
                                    >
                                        <Text color={tokens("white").txt["primary"]}>{t("shipper")}:</Text>
                                        <Box 
                                            sx={{
                                                display:"flex",
                                                alignItems:"center",
                                                justifyContent:'space-between',
                                            }}
                                        >
                                            {/* Bol collects an LvB pickup itself, so its shipper can't be changed */}
                                            <Text color={getShipperColorSettingsByType(props.isPickupReplenishment ? "bol" : props.selectedShipper?.type).base} bold>{props.isPickupReplenishment ? "Bol" : props.selectedShipper?.name}</Text>
                                            {props.currentOrder?.deliveryMethod !== "vvb" && !props.isPickupReplenishment &&
                                            <ButtonBase
                                                sx={{
                                                    ml:2,
                                                    width:32,
                                                    height:32,
                                                    // background:theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.txt["primary"],
                                                    background:getShipperColorSettingsByType(props.selectedShipper?.type).base,
                                                    color:getShipperColorSettingsByType(props.selectedShipper?.type).background,
                                                    borderRadius:5,
                                                }}
                                            >
                                                <DropdownBase
                                                    transformOrigin={{
                                                        vertical: "bottom"
                                                    }}
                                                    anchorOrigin={{
                                                        vertical:"top"
                                                    }}
                                                    displayName={"name"} 
                                                    onChange={(selected) => props.selectShipper(selected)}
                                                    noSelection={""} //Custom text when nothing is selected
                                                    options={props.shippers?.filter(shipper => shipper.type !== 'bol' || props.currentOrder?.webshopcredentials?.webshop_type === 'bol')}
                                                    selected={-1}
                                                    closeOnSelection
                                                    resetOnSelection
                                                >
                                                    <EditOutlinedIcon/>
                                                </DropdownBase>
                                            </ButtonBase>
                                            }
                                        </Box>
                                    </Box>
                                    
                                </Box>
                                
                                <Box
                                    sx={{
                                        mt:2,
                                    }}
                                >
                                    {!props.isPickupReplenishment && (
                                    <Box >
                                        <Text color={tokens("white").txt["primary"]}>{t("shipperprofile")}:</Text><br/>
                                        <Box
                                            sx={{
                                                display:"flex",
                                                justifyContent:'space-between',
                                                alignItems:'center',
                                            }}
                                        >
                                            <Text color={getShipperColorSettingsByType(props.selectedShipper?.type).base} bold>{props.selectedShipperProfile?.name}</Text>
                                            <ButtonBase
                                                sx={{
                                                    width:32,
                                                    height:32,
                                                    background:getShipperColorSettingsByType(props.selectedShipper?.type).base,
                                                    color:getShipperColorSettingsByType(props.selectedShipper?.type).background,
                                                    borderRadius:5,
                                                }}
                                            >
                                                <DropdownBase
                                                    transformOrigin={{
                                                        vertical: "bottom"
                                                    }}
                                                    anchorOrigin={{
                                                        vertical:"top"
                                                    }}
                                                    displayName={"name"}
                                                    onChange={(selected) => props.selectShipperProfile(selected)}
                                                    noSelection={""} //Custom text when nothing is selected
                                                    options={filterShipperProfilesByDeliveryCountry(props.selectedShipper?.shipperProfiles, getOrderDeliveryCountry(props.currentOrder))}
                                                    selected={-1}
                                                    closeOnSelection
                                                    resetOnSelection
                                                    searchOptions={{
                                                        enabled: true,
                                                        placeholder: t("search_shipper_profile"),
                                                        allowSelectionOnEnter: true
                                                    }}
                                                >
                                                    <EditOutlinedIcon/>
                                                </DropdownBase>
                                            </ButtonBase>
                                        </Box>
                                    </Box>
                                    )}

                                    {/* This is to show what type of bol label was pre selected */}
                                    {props.selectedShipper?.type === "bol" && (
                                        <Box >
                                            <Text color={tokens("white").txt["primary"]}>{t("selected_label")}:</Text><br/>
                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    justifyContent:'space-between',
                                                    alignItems:'center',
                                                }}
                                            >
                                                <Text color={getShipperColorSettingsByType(props.selectedShipper?.type).base} bold>{props.currentOrder?.labelData?.labelInfo?.labelDisplayName ?? t("label_to_be_determined")}</Text>
                                            </Box>
                                        </Box>
                                    )}
                                    {props.currentOrder?.bolReplenishmentId > 0 && (
                                        <Box
                                            sx={{
                                                mt:2,
                                            }}
                                        >
                                            <Box >
                                                <Text color={tokens("white").txt["primary"]}>{t(props.isPickupReplenishment ? "pickup_time" : "bol_delivery_time")}:</Text><br/>
                                                <Box
                                                    sx={{
                                                        display:"flex",
                                                        justifyContent:'space-between',
                                                        alignItems:'center',
                                                    }}
                                                >
                                                    <Text color={getShipperColorSettingsByType(props.selectedShipper?.type).base} bold>{props.selectedTimeSlot?.name ?? props.selectedTimeSlot}</Text>
                                                    <ButtonBase
                                                        sx={{
                                                            width:32,
                                                            height:32,
                                                            background:getShipperColorSettingsByType(props.selectedShipper?.type).base,
                                                            color:getShipperColorSettingsByType(props.selectedShipper?.type).background,
                                                            borderRadius:5,
                                                        }}
                                                    >
                                                        <DropdownBase
                                                            transformOrigin={{
                                                                vertical: "bottom"
                                                            }}
                                                            anchorOrigin={{
                                                                vertical:"top"
                                                            }}
                                                            displayName={"name"} 
                                                            onChange={(selected) => props.selectTimeSlot(selected)}
                                                            noSelection={""} //Custom text when nothing is selected
                                                            options={props.selectedTimeSlotOptions}
                                                            selected={-1}
                                                            closeOnSelection
                                                            resetOnSelection
                                                        >
                                                            <EditOutlinedIcon/>
                                                        </DropdownBase>
                                                    </ButtonBase>
                                                </Box>
                                                {props.isPickupReplenishment && props.pickupTimeSlotError && (
                                                    <Text bold variant={"red"}>{props.pickupTimeSlotError}</Text>
                                                )}
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            
                                {props.showOptions && 
                                    <Box
                                        sx={{
                                            mt:2,
                                            borderRadius:3,
                                            mx:-1.5,
                                            px:1.5,
                                            py:1,
                                            background:theme.palette.mode === "dark" ? colors.grey[400]: colors.grey[50],
                                            display:"flex",
                                            flexDirection:'column',
                                            gap:1,
                                            overflow:"hidden"
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display:"flex",
                                                alignItems:"center",
                                                gap:2
                                            }}
                                        >
                                            <Text noBreak>Print pakbon per drager</Text>
                                            <ShSwitch/>
                                        </Box>

                                        <Box
                                            sx={{
                                                display:"flex",
                                                alignItems:"center",
                                                gap:2
                                            }}
                                        >
                                            <Text noBreak>Print pallet pakbonnen</Text>
                                            <ShSwitch/>
                                        </Box>

                                        <Box
                                            sx={{
                                                display:"flex",
                                                // alignItems:"center",
                                                flexDirection:'column'
                                                // gap:2
                                            }}
                                        >
                                            <Text noBreak>Print pakbon met draagnummers na voltooien order</Text>
                                            <ShSwitch/>
                                        </Box>
                                    </Box> 
                                }
                            </Box>
                            {hasOutboundInstructions &&
                                <Box
                                    sx={{
                                        background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                                        // border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                        mt:1.5,
                                        p:1.5,
                                        borderRadius:3,
                                    }}
                                >
                                    <Subheading>
                                        {t("instructions")}
                                    </Subheading>
                                    {props.toScanRows
                                    ?.filter(row => {
                                        const instr = row.product?.outboundInstruction;
                                        return instr && instr.trim().length > 0;   // keep only non-empty strings
                                    }).map((row) => (
                                        <Box
                                            sx={{
                                                mt:1.5,
                                                display:"flex",
                                                flexDirection:"column",
                                            }}
                                        >
                                            <Text>{row.product.sku}</Text>
                                            <Box
                                                sx={{
                                                    mt:0.5,
                                                    p:1,
                                                    px:1.5,
                                                    background:theme.palette.mode === "dark" ? colors.grey[700] : colors.grey[100],
                                                    borderRadius:4,
                                                }}
                                            >
                                                <Text>{row.product.outboundInstruction}</Text>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            }

                    </Box>
                </Box>

                <Box
                    sx={{
                        width:1,
                        mt:"auto",
                        mx:"auto",
                        display:'flex',
                        justifyContent:'center',
                        alignItems:'center',
                        mb:4,
                    }}
                >
                    <Box
                        sx={{
                            position:'absolute',
                            width:"60%",
                        }}
                    >
                        <Slide
                            direction="up" 
                            // in={finalizeLoading || finalizeFetching}
                            in={props.showSlide}
                            // in
                        >
                            <Box
                                sx={{ 
                                    borderRadius:8,
                                    background:"#fff",
                                    width:1,
                                    height:65,
                                    display:"flex",
                                    justifyContent:"space-between",
                                    alignItems:'center',
                                    px:3,
                                    position:'relative',
                                    zIndex:1,
                                    overflow:'visible',
                                    "&:before" : {
                                        position:'absolute',
                                        content:"''",
                                        left:6,
                                        right:6,
                                        top:6,
                                        bottom:6,
                                        zIndex:-1,
                                        borderRadius:12,
                                        filter:"blur(12px)",
                                        background: 'linear-gradient(var(--gradient-angle), #31415f, #0D61FF, #C2D7FF)',
                                        animation: 'rotation 5s linear infinite'
                                    },
                                    "&:after" : {
                                        position:'absolute',
                                        content:"''",
                                        left:0,
                                        right:0,
                                        top:0,
                                        bottom:0,
                                        zIndex:-1,
                                        borderRadius:12,
                                        background:'#fff'
                                    }
                                }}
                            >
                                <Box width={60} />
                                <Subheading>
                                    {t('e_check_you_have_5_seconds')}
                                </Subheading>
                                <Box width={60} />
                            </Box>
                        </Slide>
                    </Box>

                    <Box
                        sx={{
                            position:'absolute',
                            width:"60%",
                        }}
                    >
                        <Slide 
                            direction="up" 
                            in={props.finalizeLoading || props.finalizeFetching}
                        >
                            <Box
                                sx={{ 
                                    borderRadius:8,
                                    background:"#fff",
                                    width:1,
                                    height:65,
                                    display:"flex",
                                    justifyContent:"space-between",
                                    alignItems:'center',
                                    px:3,
                                    position:'relative',
                                    zIndex:1,
                                    // left:"50%",
                                    // transform:"translateX(-50%)",
                                    overflow:'visible',
                                    "&:before" : {
                                        position:'absolute',
                                        content:"''",
                                        left:6,
                                        right:6,
                                        top:6,
                                        bottom:6,
                                        zIndex:-1,
                                        borderRadius:12,
                                        filter:"blur(12px)",
                                        background: 'linear-gradient(var(--gradient-angle), #31415f, #0D61FF, #C2D7FF)',
                                        animation: 'rotation 5s linear infinite'
                                    },
                                    "&:after" : {
                                        position:'absolute',
                                        content:"''",
                                        left:0,
                                        right:0,
                                        top:0,
                                        bottom:0,
                                        zIndex:-1,
                                        borderRadius:12,
                                        background:'#fff'
                                    }
                                }}
                            >
                                <Box width={60} />
                                <Subheading>
                                    {t(textKey === 'echeck_processing_order' && props.finalizingWithoutLabel ? 'echeck_processing_order_without_label' : textKey)}
                                </Subheading>
                                <Truck/>
                            </Box>
                        </Slide>
                    </Box>
                </Box>

            </Box>
            {spLoading && 
                <SpOrderDetails
                    isExtended={orderOpen}
                    setIsExtended={setOrderOpen}
                    orderId={orderId}
                    defaultTab={2}
                    // data={orderData}
                /> 
            }
        </>

    );
}

export default EcheckView;